import { render, staticRenderFns } from "./dialog-boxbototp.vue?vue&type=template&id=1768f5f2&scoped=true&"
import script from "./dialog-boxbototp.vue?vue&type=script&lang=js&"
export * from "./dialog-boxbototp.vue?vue&type=script&lang=js&"
import style0 from "./dialog-boxbototp.vue?vue&type=style&index=0&id=1768f5f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1768f5f2",
  null
  
)

export default component.exports